module.exports = __webpack_public_path__ + "img/1514956511.b37044a2.jpg";